module.exports = __webpack_public_path__ + "static/media/Haier_Europe_Logo_Login.eeef4db4.png";